var _g, _g2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeighborhood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.57,
    y: 88.407,
    style: {
      fill: "#E8E8E8"
    },
    width: 186.217,
    height: 144.717
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2FA65B"
    },
    points: "203.328,23.5 83.088,23.5 49.57,88.409 235.782,88.409 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.138,
    y: 158.639,
    style: {
      fill: "#84B3D2"
    },
    width: 51.078,
    height: 74.485
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.215,
    y: 88.407,
    style: {
      fill: "#E8E8E8"
    },
    width: 186.217,
    height: 144.717
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2FA65B"
    },
    points: "429.976,23.5 309.736,23.5 276.218,88.409 462.43,88.409 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.785,
    y: 158.639,
    style: {
      fill: "#84B3D2"
    },
    width: 51.078,
    height: 74.485
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.57,
    y: 343.785,
    style: {
      fill: "#E8E8E8"
    },
    width: 186.217,
    height: 144.717
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2FA65B"
    },
    points: "203.328,278.878 83.088,278.878 49.57,343.786 235.782,343.786 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.138,
    y: 414.017,
    style: {
      fill: "#84B3D2"
    },
    width: 51.078,
    height: 74.485
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.215,
    y: 343.785,
    style: {
      fill: "#E8E8E8"
    },
    width: 186.217,
    height: 144.717
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2FA65B"
    },
    points: "429.976,278.878 309.736,278.878 276.218,343.786 462.43,343.786 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.785,
    y: 414.017,
    style: {
      fill: "#84B3D2"
    },
    width: 51.078,
    height: 74.485
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.801,243.322c5.633,0,10.199-4.566,10.199-10.199c0-5.633-4.566-10.199-10.199-10.199h-29.172V88.409 c0-1.622-0.389-3.148-1.062-4.51c-0.006-0.017-0.006-0.034-0.015-0.052l-32.454-64.909c-1.728-3.455-5.26-5.638-9.122-5.638h-120.24 c-3.816,0-7.312,2.13-9.062,5.52l-33.518,64.909c-0.004,0.008-0.002,0.015-0.005,0.023c-0.719,1.397-1.132,2.977-1.132,4.656 v134.515h-20.037V88.409c0-1.623-0.389-3.151-1.063-4.512c-0.006-0.016-0.005-0.033-0.014-0.049L212.45,18.939 c-1.728-3.455-5.26-5.638-9.122-5.638H83.088c-3.816,0-7.312,2.13-9.062,5.52L40.507,83.729c-0.005,0.01-0.004,0.02-0.008,0.031 c-0.717,1.395-1.129,2.973-1.129,4.649v134.515H10.199C4.566,222.923,0,227.49,0,233.123c0,5.633,4.566,10.199,10.199,10.199 H501.801z M127.338,222.923v-54.086h30.677v54.086H127.338z M353.985,222.923v-54.086h30.677v54.086H353.985z M315.948,33.7h107.725 l22.255,44.51H292.963L315.948,33.7z M286.417,98.608h165.815v124.316h-47.17v-64.286c0-5.633-4.566-10.199-10.199-10.199h-51.076 c-5.633,0-10.199,4.566-10.199,10.199v64.286h-47.17V98.608z M89.3,33.7h107.725l22.255,44.51H66.315L89.3,33.7z M59.769,98.608 h165.815v124.316h-47.17v-64.286c0-5.633-4.566-10.199-10.199-10.199h-51.076c-5.633,0-10.199,4.566-10.199,10.199v64.286h-47.17 V98.608z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M501.801,498.7c5.633,0,10.199-4.566,10.199-10.199s-4.566-10.199-10.199-10.199h-29.172V343.786 c0-1.628-0.391-3.161-1.069-4.525c-0.004-0.012-0.002-0.023-0.008-0.036l-32.454-64.909c-1.728-3.456-5.26-5.638-9.122-5.638 h-120.24c-3.816,0-7.312,2.13-9.062,5.52l-33.518,64.909c-0.005,0.01-0.003,0.019-0.008,0.03c-0.717,1.395-1.129,2.974-1.129,4.651 v134.515h-20.037V343.786c0-1.623-0.389-3.152-1.064-4.514c-0.006-0.016-0.005-0.032-0.013-0.048l-32.454-64.909 c-1.728-3.455-5.26-5.638-9.122-5.638H83.088c-3.816,0-7.312,2.13-9.062,5.52l-33.519,64.909c-0.004,0.008-0.001,0.015-0.005,0.023 c-0.719,1.397-1.132,2.977-1.132,4.657v134.515H10.199C4.566,478.301,0,482.868,0,488.501S4.566,498.7,10.199,498.7H501.801z M315.948,289.078h107.725l22.255,44.51H292.963L315.948,289.078z M89.3,289.078h107.725l22.255,44.51H66.315L89.3,289.078z M127.338,478.301v-54.086h30.677v54.086H127.338z M178.414,478.301v-64.286c0-5.633-4.566-10.199-10.199-10.199h-51.076 c-5.633,0-10.199,4.566-10.199,10.199v64.286h-47.17V353.985h165.815v124.316H178.414z M353.985,478.301v-54.086h30.677v54.086 H353.985z M405.06,478.301v-64.286c0-5.633-4.566-10.199-10.199-10.199h-51.076c-5.633,0-10.199,4.566-10.199,10.199v64.286h-47.17 V353.985h165.815v124.316H405.06z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.87,363.382h-3.192c-5.633,0-10.199,4.566-10.199,10.199s4.566,10.199,10.199,10.199h3.192 c5.633,0,10.199-4.566,10.199-10.199S342.503,363.382,336.87,363.382z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M433.7,363.382h-61.716c-5.633,0-10.199,4.566-10.199,10.199s4.566,10.199,10.199,10.199H433.7 c5.633,0,10.199-4.566,10.199-10.199S439.333,363.382,433.7,363.382z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeighborhood);
export default __webpack_public_path__ + "static/media/neighborhood.a60327ec2e4606db684c14e09275b03c.svg";
export { ForwardRef as ReactComponent };